import { Box, type BoxProps } from '@mui/material';
import { getCountryFlagFallbackUrls, getCountryFlagUrl, getNextCountryFlagFallbackUrl } from '../../utils/countryFlags';
import { getMinioUrl } from '../../utils/urlUtils';
import { useMarketplaceConfig } from '../../queries/marketplace';

import { mergeSx } from '../../utils/styles';

type CompetitionFlagProps = {
  name: string;
  width?: number | string;
  height?: number | string;
  sx?: BoxProps['sx'];
};

export const CompetitionFlag = ({ name, width = 20, height = 20, sx }: CompetitionFlagProps) => {
  const { data: marketplaceConfig } = useMarketplaceConfig();
  const flagVariant = marketplaceConfig?.sportsbookConfig?.assetVariants?.competitionsFlags;

  if (!name) {
    return null;
  }

  const minioBaseUrl = getMinioUrl();
  const flagUrl = getCountryFlagUrl({ minioBaseUrl, name, variant: flagVariant });
  const fallbackUrls = getCountryFlagFallbackUrls({ minioBaseUrl, variant: flagVariant });

  return (
    <Box
      component='img'
      src={flagUrl}
      alt={name}
      onError={(e) => {
        const img = e.currentTarget as HTMLImageElement;
        const nextFallbackUrl = getNextCountryFlagFallbackUrl({
          currentUrl: img.getAttribute('src'),
          fallbackUrls,
        });

        if (nextFallbackUrl) {
          img.src = nextFallbackUrl;
          return;
        }

        img.style.display = 'none';
      }}
      loading='lazy'
      sx={mergeSx(
        {
          width: width,
          height: height,
        },
        ...(Array.isArray(sx) ? sx : [sx])
      )}
    />
  );
};
